export default "__VITE_ASSET__B69aeR3A__"